import { bl_pos_float_count_line_RowClass } from '../../../dbschema';
import { bl_pos_float_count_hdr_RowClass } from '../../../dbschema/bl_pos_float_count_hdr.model';
import {BaseContainerModel} from '../../base-container.model';


export class PosFloatCountContainerModel extends BaseContainerModel {
  bl_pos_float_count_hdr: bl_pos_float_count_hdr_RowClass = new bl_pos_float_count_hdr_RowClass();
  bl_pos_float_count_line: bl_pos_float_count_line_RowClass[] = [];
}
